import { createRoot } from 'react-dom/client';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import App from './App';
import './main.css';
import { initPwaInstallCapture } from "./pwa/installPrompt";

//const UserContext = React.createContext(null);

initPwaInstallCapture();

/*if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(reg => {
      //console.log('[app] SW registered:', reg.scope);
    }).catch(err => {
      console.error('[app] SW registration failed:', err);
    });
  });
}*/

defineCustomElements(window);

document.body.classList.remove('dark');

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    {/*<React.StrictMode>*/}
      <App />
    {/*</React.StrictMode>*/}
  </>
);